import UserQuery from "../../domain/core/user/UserQuery";
import { UserModel } from "../../domain/models/User";
import { IQueryUserRepository } from "../../domain/ports/user/IQueryUserRepository";
import QueryService from "../QueryService";

export class UserQueryService
  extends QueryService<UserModel>
  implements IQueryUserRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }

  public async fetchCurrentUser(): Promise<UserModel | null> {
    try {
      const response = await this.api.get("/current-user");
      return response.data;
    } catch (error) {
      console.error("Error retrieving the user", error);
      throw error;
    }
  }

  public async searchByIds(ids: string[]): Promise<UserModel[]> {
    if (ids.length === 0) return [];
    const response = await this.api.post(`${this.pathname}/search`, {
      search: {
        filters: [{ field: "id", operator: "in", value: ids }],
      },
    });
    return response.data;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const userQueryServiceForUsers = new UserQuery(
  new UserQueryService(BASE_URL, "users"),
);

export { userQueryServiceForUsers };
